import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shop-full-width-page',
  templateUrl: './shop-full-width-page.component.html',
  styleUrls: ['./shop-full-width-page.component.scss']
})
export class ShopFullWidthPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
